import GalleryResultModel from "../model/gallery_result_model";
import ImageModel from "../model/image_model";

export const toGalleryResultModel = (object) => {
  console.log("Gallery Map Object", object.data[0].result);
  const images = [];
  object.data[0].result.forEach((item) => {
    const image = new ImageModel({
      id: item.id,
      imageUrl: item.fileUrl,
      imageName: item.fileName,
      createdDate: Date.now(),
      isBlur: item.isBlur,
    });
    images.push(image);
  });
  return new GalleryResultModel({
    success: object.success,
    message: object.message,
    total: object.data[0].total,
    images: images,
  });
};
